import {Controller} from 'stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['studentType', 'parentType', 'studentFields', 'grade', 'books', 'noBooks']

  connect () {
    this.change()
  }

  change () {
    const displayStudentFields = this.studentTypeTarget.checked ||
      this.parentTypeTarget.checked
    this.studentFieldsTarget.style.display = displayStudentFields ? 'initial' : 'none'

    // Only the request sheet asks for the books to match the grade, so the
    // books target is absent on the forms that let staff assign any book.
    if (this.hasBooksTarget) {
      // The grade is only asked of students and parents; a teacher picks from
      // every book.
      this.filterBooks(displayStudentFields ? this.gradeTarget.value : '')
    }
  }

  filterBooks (grade) {
    const select = this.booksTarget

    if (this.bookOptions == null) {
      this.bookOptions = Array.from(select.options)
    }

    const visible = this.bookOptions.filter((option) => {
      if (option.value === '' || option.selected) return true
      if (grade === '') return true

      // A book with no grade of its own is offered for every grade, so leaving
      // it blank never makes a book impossible to request.
      const grades = option.dataset.grades || ''
      return grades === '' || grades.split(' ').includes(grade)
    })

    select.innerHTML = ''
    visible.forEach((option) => select.appendChild(option))

    // Redraw the select2 widget, which reads its options straight off the
    // select each time the dropdown opens.
    $(select).trigger('change.select2')

    if (this.hasNoBooksTarget) {
      // The grades come from every book the ministry has ever listed, so a
      // requester can pick one that nothing on offer is for.
      const offered = visible.some((option) => option.value !== '')
      this.noBooksTarget.hidden = grade === '' || offered
    }
  }
}
